import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=467fff7f&scoped=true"
import script from "./AdminLogin.vue?vue&type=script&lang=ts"
export * from "./AdminLogin.vue?vue&type=script&lang=ts"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=467fff7f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467fff7f",
  null
  
)

export default component.exports